/**
 * Exposing intl-tel-input as a component
 */
module.exports = require("./build/js/intlTelInput");



// WEBPACK FOOTER //
// ./node_modules/intl-tel-input/index.js